export default __webpack_public_path__ + "static/media/cuda.8daef014.svg";